export class Logger {
    static error(message, ...args) {
        // eslint-disable-next-line no-console
        console.error(`${this.prefix} ${message}`, ...args);
    }
    static warn(message, ...args) {
        // eslint-disable-next-line no-console
        console.warn(`${this.prefix} ${message}`, ...args);
    }
    static info(message, ...args) {
        if (window.gpsa_shared?.wp_debug) {
            // eslint-disable-next-line no-console
            console.info(`${this.prefix} ${message}`, ...args);
        }
    }
    static debug(message, ...args) {
        // Only log debug messages if WP_DEBUG is enabled
        if (window.gpsa_shared?.wp_debug) {
            // eslint-disable-next-line no-console
            console.debug(`${this.prefix} ${message}`, ...args);
        }
    }
}
Logger.prefix = '[GPSA]';
